import { render } from "./Calculation.vue?vue&type=template&id=5855cd89"
import script from "./Calculation.vue?vue&type=script&lang=js"
export * from "./Calculation.vue?vue&type=script&lang=js"

import "./Calculation.vue?vue&type=style&index=0&id=5855cd89&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__